// extracted by mini-css-extract-plugin
export default {"container":"Forfait_container__Vw4nW","discountContainer":"Forfait_discountContainer__BrhcR"};